<template>
    <span>{{this.params.data.pending === 0 ? 'not pending' : 'pending'}}</span>
</template>

<script>
    export default {
        name: 'CellRendererPending'
    }
</script>
